export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5581.ed2e8204.jpg";